import { PropsWithChildren } from 'react'
import { Box } from '@mui/material'
import clsx from 'clsx'

import { Drawer } from 'components/Drawer'
import Header from 'components/Header/Header'
import { StepContainer } from 'components/StepContainer'
import StyledWrap from 'components/StyledWrap'
import { useFlow } from 'utils/flow'
import { useBoolean, useCurrentPage } from 'utils/hook'

const Layout = ({ children }: PropsWithChildren): JSX.Element => {
  const { data: flowData } = useFlow()

  const [isDrawerOpen, openDrawer, closeDrawer] = useBoolean(false)

  const { name: pageName } = useCurrentPage()

  return (
    <StyledWrap elementName="MainWrap">
      <Box
        className={clsx({ [`page-${pageName}`]: flowData?.theme?.stylings.MainWrap !== undefined })}
        sx={{ display: 'flex' }}
      >
        <Header openDrawer={openDrawer} />
        <Drawer open={isDrawerOpen} onClose={closeDrawer} />
        <StepContainer>{children}</StepContainer>
      </Box>
    </StyledWrap>
  )
}

export default Layout
